export default {
  'Default': require('!raw!examples/default'),
  'Binaural Beat': require('!raw!examples/binaural'),
  'Filtered Noise': require('!raw!examples/filtered_noise'),
  'Sea': require('!raw!examples/sea'),
  'Exhale': require('!raw!examples/exhale'),
  'Arpeggio + Sequencer': require('!raw!examples/arpeggio_sequencer'),
  'THX Clone': require('!raw!examples/thx_clone'),
  'Popping (WIP)': require('!raw!examples/popping_wip'),
}



// WEBPACK FOOTER //
// ../examples/index.js